var _path, _path2, _path3, _circle, _g, _use, _path4, _use2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 600,
    height: 400,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h600v400H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M600 400H0L600 0z",
    fill: "#012a87"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0v166.667L250 0z",
    fill: "#f9d90f"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 173,
    r: 80,
    fill: "none",
    stroke: "#000",
    strokeWidth: 11
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165 69.834l15 25.981h-30z",
    fill: "#000",
    id: "a"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(180 165 173)"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "rotate(90 165 173)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M165 122l44.167 76.5h-88.334z",
    fill: "#dc171d",
    id: "c"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(60 165 173)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBq);
export default __webpack_public_path__ + "static/media/bq.810d1964c48f4391996b0ee44f69580d.svg";
export { ForwardRef as ReactComponent };